import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const createShotclass = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.CREATE_SHOTCLASS,
    data
  );
};

export default createShotclass;
